import Loader from '__components/Kizen/Loader';
import { IconSizing } from '__components/Kizen/Icon';
import styled from '@emotion/styled';
import css from '@emotion/css';

export const AbsoluteLoader = styled(Loader)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background: var(--color-background-white);

  ${({ transparent }) =>
    transparent &&
    css`
      opacity: 0;
      background: transparent;
      animation: fadeIn 0.3s forwards;
      animation-delay: 0.2s;

      @keyframes fadeIn {
        to {
          opacity: 1;
        }
      }
    `}

  ${({ inline }) =>
    inline
      ? css`
          padding-top: 0 !important;
          display: flex;
          align-items: center;
          justify-content: center;
        `
      : ''}
`;

export const ModalWrapper = styled.div`
  gap: 15px;
  display: flex;
  flex-direction: column;
`;

export const InlineSetupViewWrapper = styled.div`
  margin: -20px;
  border-radius: inherit;
  overflow: hidden;
`;

export const ContainerRow = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: ${({ columns }) =>
    `repeat(${columns}, minmax(0, 1fr))`};
  gap: 15px;
`;

export const LabelInfoIconSizing = styled(IconSizing)`
  margin-left: 5px;
  vertical-align: middle;
  margin-bottom: 2px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;
